'use strict';

const KEY = `plaid->pending-saves`;

export const getPendingSaves = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const storePendingSave = (taskItemId, taskId, fields) => {
  if (!taskItemId) return;
  try {
    const pending = getPendingSaves().filter((s) => s.taskItemId !== taskItemId);
    pending.push({ taskItemId, taskId, fields, timestamp: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(pending));
  } catch (e) { /* localStorage unavailable */ }
};

export const clearPendingSave = (taskItemId) => {
  try {
    const pending = getPendingSaves().filter((s) => s.taskItemId !== taskItemId);
    localStorage.setItem(KEY, JSON.stringify(pending));
  } catch (e) { /* localStorage unavailable */ }
};

export const hasPendingSave = (taskItemId) => {
  return getPendingSaves().some((s) => s.taskItemId === taskItemId);
};



// WEBPACK FOOTER //
// ./src/helpers/PendingSaveHelper.js